/* @flow */

import type { $BaseWidgetState } from '../types/BaseWidgetState';
import type { $TrackingEvent } from '../types/TrackingEvent';
import { TrackingAttributes } from '../constants/Tracking';
import { getDeepPropertyValue } from './WidgetUtils';
import packageJSON from '../../package.json';

/* IE11 FFS */
function createNewEvent(eventName) {
  let event;
  if (typeof(Event) === 'function') event = new Event(eventName);
  else {
    event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
  }
  return event;
}

export function trackEvent(event: $TrackingEvent) {
  if (!window.dataLayer) window.dataLayer = [];
  window.dataLayer.push(event);
  const dlcEvent = createNewEvent(TrackingAttributes.DLC_EVENT_NAME);
  window.dispatchEvent(dlcEvent);
}

export function setBaseData(state: $BaseWidgetState) {
  const event: $TrackingEvent = {
    application: {
      id: TrackingAttributes.APPLICATION_ID,
      version: packageJSON.version,
      parentApplicationId: getDeepPropertyValue(['configuration', 'application', 'applicationId'], state) || '',
      configId: getDeepPropertyValue(['configuration', 'baseInfo', 'externalId'], state) || '',
      market: getDeepPropertyValue(['settings', 'market'], state) || '',
      language: getDeepPropertyValue(['settings', 'language'], state) || '',
      searchProfileName: getDeepPropertyValue(['settings', 'searchProfileName'], state) || ''
    }
  };
  return event;
}
